/**
 * Converts a billing vendor name from the legacy billing schema (e.g., 'Amazon', 'Google')
 * to the corresponding provider name in the FOCUS schema (e.g., 'AWS', 'Google Cloud').
 *
 * If the vendor is not recognized, returns the input unchanged.
 *
 * @param billingVendor - The vendor name from the billing schema.
 * @returns The mapped provider name for FOCUS schema, or the input if no match is found.
 */
export function translateBillingVendorToFocusProvider(
  billingVendor: string
): string {
  switch (billingVendor) {
    case "Amazon":
      return "AWS";
    case "Google":
      return "Google Cloud";
    default:
      return billingVendor;
  }
}
